/* ====================================================================
   Lunai bundle — "Dodaj cel set v košarico" on moment pages.
   Reads comma-separated variant IDs from [data-bundle-add]
   [data-variant-ids] and adds them all via /cart/add.js.

   P-09: the cart page is the single cart surface, so a bundle add is a
   QUIET add like every other one — the header bubble ticks and the live
   region announces it. It no longer force-navigates to /cart, and it no
   longer asks Shopify to render a drawer section that isn't there.
   ==================================================================== */
(function () {
  function refreshCartUI(state) {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.renderContents === 'function') {
      cd.classList.remove('is-empty');
      cd.renderContents(state);
      if (typeof cd.open === 'function') cd.open();
      return true;
    }
    return false;
  }
  function live() {
    var el = document.getElementById('lunai-live');
    if (!el) {
      el = document.createElement('div');
      el.id = 'lunai-live';
      el.className = 'visually-hidden';
      /* keep attributes identical to the other #lunai-live creators —
         whichever runs first owns the shared singleton */
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    return el;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-add]');
    if (!btn) return;
    e.preventDefault();
    var ids = (btn.getAttribute('data-variant-ids') || '')
      .split(',').map(function (s) { return parseInt(s.trim(), 10); })
      .filter(function (n) { return n > 0; });
    if (!ids.length) return;
    var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = (window.lunaiStrings || {})['cart.bundle_adding'] || '';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: document.querySelector('cart-drawer') ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble'
      })
    })
      .then(function (r) {
        /* 422 = an item sold out since page render (multi-item add is
           all-or-nothing) — surface it instead of dumping on /cart */
        if (!r.ok) throw new Error('bundle-add-failed');
        return r.json();
      })
      .then(function (state) {
        // header cart bubble — extract the inner markup, not the section wrapper
        if (state.sections && state.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var doc = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html');
            var freshBubble = doc.getElementById('cart-icon-bubble') || doc.body.firstElementChild;
            bubble.innerHTML = freshBubble ? freshBubble.innerHTML : state.sections['cart-icon-bubble'];
          }
        }
        if (!refreshCartUI(state)) {
          /* P-09: no drawer — stay where we are. The bubble above has
             already ticked; announce it for anyone who can't see it. */
          btn.classList.add('is-done');
          setTimeout(function () { btn.classList.remove('is-done'); }, 1600);
          live().textContent = (window.lunaiStrings || {})['cart.added_announcement'] || '';
        }
      })
      .catch(function () {
        btn.classList.add('is-error');
        live().textContent = (window.lunaiStrings || {})['cart.add_error'] || 'Dodajanje ni uspelo. Poskusite znova.';
        setTimeout(function () { btn.classList.remove('is-error'); }, 2200);
      })
      .then(function () { btn.disabled = false; btn.innerHTML = original; });
  });
})();
